/*
 * @Author: 小周
 * @Date: 2023-10-13 10:53:50
 * @LastEditTime: 2024-06-12 11:06:38
 * @LastEditors: MrZHLF
 * @Description: 获取设备环境
 */

import { useState, useEffect } from 'react'
import { isCheckApp } from '../utils/index'

/**
 *
 * @description 判断当前设备否是APP或者H5
 */
function useGetDeviceType() {
  const [deviceType, setDeviceType] = useState(true)

  useEffect(() => {
    if (isCheckApp()) {
      setDeviceType(true)
    } else {
      setDeviceType(false)
    }
  }, [deviceType])

  return {
    deviceType,
  }
}

export default useGetDeviceType
